// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"d02a6bbe","241":"1d9cff0a","265":"267ccb93","331":"6e27ab64","436":"79f467b9","453":"8ee3e876","517":"79c6fcff","591":"fb032f1a","606":"b61375da","637":"07318c95","708":"c7c0b201","940":"31661296"}[chunkId] + ".chunk.js";
};